<template>
  <div class="width-expand">
    <base-form
      ref="searchForm"
      v-bind="$attrs"
      v-model="searchModel"
      method="get"
      :action="searchUrl"
      class="width-expand"
      :error-display-position="'absolute'"
      :field-wrapper-margin="false"
      :config="searchFormConfig"
      @form:submitProcessStart="handleSearchStart"
      @submit="handleSearchStart"
      @form:submitEnd="handleSearchSubmitComplete"></base-form>

    <drawer

      v-model="isShowingResultUi"
      location="bottom"
      class=""
      :offset="'100px'">

      <div
        v-if="!isSearching && hasResults"
        class="animate__fadeIn animate--fast results container container-m min-height-200">
        <h3 class="h2 results-title text-center">
          {{ translateUcFirst("core.search.resultCountTitle", { count: resultCount }) }}
        </h3>
        <div class="results flex-wrap gap-l m:flex-start flex-center flex-stretch">
          <component
            :is="getResultComponent(item)"
            v-for="item in results"
            :item="item"
            @search-result-item:request-close="close"
            @list-item:request-close="close">
            <span>TEST</span>
          </component>
        </div>
        <div class="flex-column flex-middle flex-center margin-2xl-top">
          <h3 class="h2 c-lead results-title text-center margin-m-bottom">
            {{ translateUcFirst("core.search.newSearchExplain") }}
          </h3>
          <form-input
            v-bind="searchFormConfig.fields.q"
            v-model="searchModel.q"
            @keyup.enter="submitMainForm()"></form-input>
        </div>
      </div>

      <div
        v-if="!isSearching && !hasResults"
        class="animate__fadeIn animate--fast results container container-m min-height-200">
        <div class="flex-column flex-middle flex-center">
          <h3 class="h2 c-lead results-title text-center margin-s-bottom">
            {{ translateUcFirst("core.search.noResultsTitle") }}
          </h3>
          <p
            class="text-xl text-center margin-auto-horizontal margin-top-remove margin-2xl-bottom">
            {{ translate("core.search.noResultsExplain") }}
          </p>
          <form-input
            v-bind="searchFormConfig.fields.q"
            v-model="searchModel.q"
            @keyup.enter="submitMainForm()"></form-input>
        </div>
      </div>

      <div
        v-if="isSearching"

        class="animate__fadeIn animate--fast loading flex flex-middle flex-center min-height-300 width-expand">
        <spinner size="4" text="core.search.searchInProgress"></spinner>
      </div>
    </drawer>
  </div>
</template>

<script>

import asyncComponentFactory from "@/client/extensions/modules/asyncComponentFactory.js";

export default {
  components: {
    // GenericListItem, VendorListItem,ProductListItem,
  },
  props: {
    fieldProps: {
      type: Object,
      default: () => ({}),
    },
    searchUrl: {
      type: String,
      default: "search/general",
    },
    formProps: {
      type: Object,
      default: () => ({
        errorDisplayPosition: "absolute",
        fieldWrapperMargin: false,
      }),
    },
  },
  data: function () {
    return {
      isShowingResultUi: false,
      isSearching: false,
      searchModel: {
        q: "",
      },
      searchFormConfig: {
        fields: {
          q: {
            name: "q",
            label: false,
            placeholder: "core.search.searchPlaceholder",
            icon: "magnify",
            type: "text",
            size: "m",
            autocomplete: false,
            ...this.fieldProps,
          },
        },
        buttons: {},
        formHandling: {},
      },
      results: [],
      resultCount: 0,
    };
  },
  computed: {
    hasResults() {
      return Array.isArray(this.results) && this.results.length > 0;
    },
    finalResults() {
      return this.results;
    },
    visibleResults() {
      return this.results;
    },
  },
  watch: {
    $route: {
      handler(newVal) {
        this.close();
      },
      deep: true,
    },
  },
  mounted() {
    if (this.$.uid === 20) {
      //   this.startSearch('מגב');
    }
  },
  methods: {
    resetSearchModel() {
      this.searchModel.q = "";
    },
    handleSearchStart() {
      this.goToResultsLoadingState();
    },
    goToResultsLoadingState() {
      this.results = [];
      this.resultCount = 0;
      this.isSearching = true;
      this.isShowingResultUi = true;
    },
    submitMainForm() {
      this.goToResultsLoadingState();
      this.$refs.searchForm.submitAsync();
    },
    handleSearchSubmitComplete({ component, data, isError, result }) {
      this.isSearching = false;

      if (isError) {
        try {
          // this form is compact, errors are a problem with the alert component
          utilities.inTwoTicks(() => {
            this.$refs.searchForm.hideSubmitError();
          });
        } catch (e) {
          console.log(e);
        }
        this.$s.ui.notification("core.search.exceptionNotification", "error");
        return false;
      }

      // success
      this.results = result.data.items;
      this.resultCount = result.data.count;
      this.isShowingResultUi = true;
    },
    startSearch(term) {
      this.searchModel.q = term;
      this.submitMainForm();
    },
    getResultComponent(resultItem) {
      let componentName = "SearchResult.vue";
      let componentPath = `components/items/${utilities.lcFirst(
        resultItem.type
      )}/${componentName}`;
      try {
        return asyncComponentFactory(componentPath, true);
      } catch (e) {
        return "div";
      }
    },
    close() {
      this.results = [];
      this.resultCount = 0;
      this.isSearching = false;
      this.isShowingResultUi = false;
    },
  },
};
</script>

<style scoped lang="scss">
.search-result {
  border: 1px solid var(--c-gray-2);
  background: var(--c-bg-4);
  border-radius: var(--border-radius-l);
  display: flex;
  gap: var(--margin-l);
  height: 120px;
  flex: 100%;
  position: relative;

  @media (max-width: 767px) {
    flex-direction: column;
    flex: 0 0 auto;
    width: 250px;
    height: auto;
    gap: var(--margin-m);
  }

  .media {
    min-height: 100%;
    flex: 0 0 120px;
    border-radius: var(--border-radius-l);

    img {
      object-fit: cover;
      max-height: 100%;
      max-width: 100%;
      height: 100%;
      width: 100%;
      border-radius: var(--border-radius-l);
    }

    @media (max-width: 767px) {
      height: 120px;
      flex: 0 0 120px;
      width: 100%;
      min-height: 120px;
    }
  }

  .mobile-badge {
    position: absolute;
    top: var(--margin-m);
    inset-inline-start: var(--margin-m);
    border-radius: var(--border-radius-l);
  }

  .content {
    padding-block: var(--margin-m);
    padding-inline-end: var(--margin-l);
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: var(--margin-xl);
    align-items: center;

    @media (max-width: 767px) {
      padding-top: 0;
      padding: var(--margin-m);
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      text-align: center;
      flex: 100%;
    }
  }

  .result-title {
    @media (max-width: 767px) {
      justify-content: center;
      text-align: center;
    }
  }

  .result-description {
    @media (max-width: 767px) {
      text-align: center;
    }
  }

  .tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: var(--margin-s);

    @media (max-width: 767px) {
      justify-content: center;
    }
  }

  .result-description {
    max-width: 100%;

    p {
      text-overflow: ellipsis;
      max-height: 1em;
      overflow: hidden;
      white-space: nowrap;
      max-width: 800px;

      @media (max-width: 1024px) {
        max-width: 300px;
      }
    }
  }

  .result-cta {
    display: flex;
    flex-direction: column;
    gap: var(--margin-m);
    padding-block: var(--margin-m);

    @media (max-width: 767px) {
      width: 100%;

      .button {
        width: 100%;
      }
    }
  }
}
</style>
